module.exports = __webpack_public_path__ + "img/info8.53d1599d.png";